<template lang="pug">
  div(class="trial-dialog")
    div(class="trial-dialog__background")
    div(class="trial-dialog__header")
      img(
        src="~/assets/images/confetti.gif"
        alt="🎉"
        class="trial-dialog__emoji"
      )
      div(class="trial-dialog__text")
        h2(class="title-32px bold") {{ titleText }}
        p(class="text-14px light trial-dialog__subtitle")
          | {{ subTitle }}
    div(class="trial-dialog__body")
      ul(class="timeline")
        li(class="timeline__item done")
          div(class="timeline__icon")
            v-icon(
              color="white"
              size="16"
            ) mdi-check
          div(class="timeline__content")
            h3(class="text-14px dark") {{ $t('Registration completed') }}
            p(class="text-12px light") {{ $t('Your profile has been created') }}

        li(class="timeline__item current")
          div(class="timeline__icon")
            e-svg-icon(
              name="unlock"
              size="sm"
            ) )
          div(class="timeline__content")
            h3(class="text-14px dark text-flex")
              | Зараз:&nbsp;
              span(class="text-14px dark") {{ $t('Full Premium Access') }}
              span(class="timeline__label ml-auto") {{ $t('Active') }}
            p(class="text-12px light") {{ textMessage }}
            ul(class="check-list")
              li(class="text-12px light") {{ $t('100 outgoing documents per month') }}
              li(class="text-12px light") {{ $t('Ready-made templates for a quick start') }}
              li(class="text-12px light") {{ $t('Structured folder system') }}
              li(class="text-12px light") {{ $t('Document approval') }}
              li(class="text-12px light") {{ $t('Database of counterparties for fast work') }}

        li(class="timeline__item")
          div(class="timeline__icon")
            e-svg-icon(
              size="sm"
              name="notification-bing"
            )
          div(class="timeline__content")
            h3(class="text-14px dark") {{ $t('Day 10: Reminder') }}
            p(class="text-12px light") {{ $t('We will send you an email with information about the end of the period') }}

        li(class="timeline__item")
          div(class="timeline__icon")
            e-svg-icon(
              name="calendar2"
              size="sm"
            )
          div(class="timeline__content")
            h3(class="text-14px dark") {{ $t('Day 14: End of Premium Access') }}
            p(class="text-12px light")
              | {{ $t('Switching to Free plan. You can continue') }}
              | {{ $t('Team rate anytime') }}

      div(class="trial-dialog__actions")
        v-btn(
          @click="finish"
          class="main-button"
        ) {{ buttonText }}
</template>

<script>
export default {
  name: 'MTrialAccessDialog',
  props: {
    isOpened: {
      type: Boolean,
      default: false
    },
    closeModal: {
      type: Function,
      default: () => {}
    },
    changeDialogWidth: {
      type: Function,
      default: () => {}
    },
    fromOnboarding: {
      type: Boolean,
      default: false
    },
    trialActivated: {
      type: Boolean,
      default: false
    },
    shouldRedirectOnFinish: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    buttonText() {
      if (this.trialActivated) return this.$t('How it works')

      return this.fromOnboarding ? this.$t('Add organization') : this.$t('Start 14-day access')
    },
    titleText() {
      return this.$t('Start 14-day access')
    },
    subTitle() {
      return `${this.$t('We have activated a free 14-day access for you')}
         ${this.$t('to the Dubidoc Premium Tariff')}`
    },
    textMessage() {
      return this.fromOnboarding
        ? this.$t('To activate access, please add your organization')
        : this.$t('All Premium functions for efficient document management')
    }
  },
  mounted() {
    this.changeDialogWidth && this.changeDialogWidth('724px')
  },

  methods: {
    finish() {
      this.closeModal(true)
      if (!this.shouldRedirectOnFinish) {
        return
      }
      if (this.fromOnboarding) {
        this.$router.push({ name: 'my-organizations' })
      }
      if (this.trialActivated) {
        this.$router.push({ name: 'documents-create' })
      }
    }
  }
}
</script>

<style lang="scss">
.trial-dialog {
  &__background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 200px;
    background: linear-gradient(91deg, #fff -29.58%, #f8e3f4 66.15%);
    z-index: -1;
  }
  &__header {
    text-align: left;
    gap: 32px;
    display: flex;
    justify-content: flex-start;
    min-height: 200px;
    background: transparent;
  }
  &__emoji {
    width: 80px;
    height: 80px;
    margin-bottom: 8px;
  }
  &__subtitle {
    margin: 8px 0 0;
    color: #676767;
    max-width: 520px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
  }
}

/* ---------- timeline ---------- */
.timeline {
  margin: 0;
  padding-left: 0 !important;
  list-style: none;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 15px;
    top: 14px;
    bottom: 24px;
    width: 2px;
    background: #e0e0e0;
    z-index: -1;
  }

  &__label {
    background-color: #f7fcf9;
    color: $success;
    font-size: 12px;
    font-weight: 400;
    padding: 8px 16px;
    border-radius: 24px;
  }

  &__item {
    display: grid;
    grid-template-columns: 40px 1fr;
    column-gap: 16px;
    margin-bottom: 32px;

    &.done .timeline__icon {
      background: #4caf50;
      color: #fff;
    }
    &.current .timeline__icon {
      border: 2px dashed #4caf50;
      background: #fff;
      align-self: start;
      margin-top: 4px;
    }
  }

  &__icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f8f8f8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
  }

  &__title {
    margin: 0 0 4px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
  }
  &__text {
    margin: 0;
    font-size: 14px;
    line-height: 1.4;
    color: #676767;
  }
}

.check-list {
  margin: 8px 0 0;
  padding: 0 !important;
  list-style: none;

  li {
    position: relative;
    padding-left: 20px;
    font-size: 14px;
    margin-bottom: 4px;

    &::before {
      content: '✔';
      position: absolute;
      left: 0;
      color: #4caf50;
      font-size: 12px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.text-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
